module.exports = __webpack_public_path__ + "092df5f6b8241c80ebdfbd5d41aee451.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/opensans-extrabold/opensans-extrabold.ttf
// module id = ./src/styles/fonts/opensans-extrabold/opensans-extrabold.ttf
// module chunks = index